var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.loading)?_c('v-progress-linear',{attrs:{"color":"primary","indeterminate":""}}):_vm._e(),_c('PatientMedia')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }